import { ROUTES } from "@/constants";
import AssignmentsPage from "@/pages/Assignments/AssignmentsPage";
import AssignmentTaskPage from "@/pages/Assignments/AssignmentTask";
import CheckoutPage from "@/pages/Checkout";
import CheckoutAddProductsPage from "@/pages/Checkout/CheckoutAddProducts";
import OrderDetailsPage from "@/pages/Checkout/OrderDetails";
import DashboardPage from "@/pages/Dashboard";
import MyRoute from "@/pages/MyRoute";
import AccountPage from "@/pages/Profile/Account";
import ChangePhonePage from "@/pages/Profile/ChangePhone";
import ProfilePage from "@/pages/Profile/MainInformation";
import CheckoutSVPage from "@/pages/SV/Checkout";
import MarketCreate from "@/pages/SV/CreatePoint";
import RouteManagementSVPage from "@/pages/SV/RouteManagement";
import AddMarketSVPage from "@/pages/SV/RouteManagement/AddPoint";
import RouteEditorSVPage from "@/pages/SV/RouteManagement/RouteEditor";
import ViewByDaysOfMonth from "@/pages/SV/RouteManagement/ViewByDaysOfMonth";
import TeamSVPage from "@/pages/SV/Team";
import MemberInfoSVPage from "@/pages/SV/Team/pages/MemberInfo";
import AboutPointPage from "@/pages/WorkPlan/AboutPoint";
import AddContractPage from "@/pages/WorkPlan/AboutPoint/InfoTab/AddContract";
import InfoTabContractsPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabContracts";
import ContractPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabContracts/Contract";
import InfoTabPlanPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabPlan";
import InfoTabShelvesPage from "@/pages/WorkPlan/AboutPoint/InfoTab/InfoTabShelves";
import MarketVerifyAddress from "@/pages/WorkPlan/MarketVerifyAddress";
import ProductDetailsPage from "@/pages/WorkPlan/ProductDetails";
import AddPhotoPage from "@/pages/WorkPlan/Tasks/AddPhoto";
import AssortmentMatrixPage from "@/pages/WorkPlan/Tasks/AssortmentMatrix";
import DMPPage from "@/pages/WorkPlan/Tasks/DMP";
import InventoryProductsPage from "@/pages/WorkPlan/Tasks/InventoryProducts";
import PaidShelfSpacePage from "@/pages/WorkPlan/Tasks/PaidShelfSpace";
import PromoPage from "@/pages/WorkPlan/Tasks/PromoCatalog";
import PromoTagPhotosPage from "@/pages/WorkPlan/Tasks/PromoTagPhotos";
import RejectProductsPage from "@/pages/WorkPlan/Tasks/RejectProducts";
import SalePage from "@/pages/WorkPlan/Tasks/SalePage";
import SendGeoPage from "@/pages/WorkPlan/Tasks/SendGeo";
import ShelfSizePage from "@/pages/WorkPlan/Tasks/ShelfSize";
import TakeDebtPage from "@/pages/WorkPlan/Tasks/TakeDebt";
import UpdateMarketInfoPage from "@/pages/WorkPlan/Tasks/UpdateMarketInfo";
import UnplannedMarketsPage from "@/pages/WorkPlan/UnplannedPoints";
import WorkPlanPage from "@/pages/WorkPlan/WorkPlanPage";
import { asyncComponentLoader } from "@/shared/routing";

import type { PathRouteCustomProps } from "./types";

export const routes: PathRouteCustomProps[] = [
    // Auth
    {
        component: asyncComponentLoader(
            () => import("@/pages/Authorization/Login"),
        ),
        path: ROUTES.Login,
        title: "Login",
        isPrivate: false,
    },
    {
        component: asyncComponentLoader(
            () => import("@/pages/Authorization/ConfirmOTP"),
        ),
        path: ROUTES.ConfirmOtp,
        title: "Confirm OTP",
        isPrivate: false,
    },

    // Profile
    {
        component: ProfilePage,
        path: ROUTES.Profile,
        title: "Profile",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam", "hos"],
    },
    {
        component: AccountPage,
        path: ROUTES.ProfileAccount,
        title: "Account",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam"],
    },
    {
        component: ChangePhonePage,
        path: ROUTES.ProfileChangePhone,
        title: "Change Phone",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },

    // Main
    {
        component: DashboardPage,
        path: ROUTES.Dashboard,
        title: "Dashboard",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam", "hos"],
    },
    {
        component: MyRoute,
        path: ROUTES.MyRoute,
        title: "MyRoute",
        isPrivate: true,
        allowedRoles: ["ta", "md"],
    },
    {
        component: AssignmentsPage,
        path: ROUTES.AssignmentsPage,
        title: "Assignments",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },

    // Work plan
    {
        component: WorkPlanPage,
        path: "/work-plan",
        title: "Work Plan",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    {
        component: UnplannedMarketsPage,
        path: ROUTES.WorkPlanUnplannedPoint,
        title: "Unplanned Markets",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },

    // Point details
    {
        component: AboutPointPage,
        path: ROUTES.PointDetails,
        title: "Point details",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam"],
    },
    {
        component: MarketVerifyAddress,
        path: ROUTES.MarketVerifyAddress,
        title: "Verify address",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: InfoTabContractsPage,
        path: ROUTES.PointContracts,
        title: "Market contracts",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "svm", "md", "kam"],
    },
    {
        component: ContractPage,
        path: ROUTES.PointContractDetail,
        title: "Market contract",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "svm", "md", "kam"],
    },
    {
        component: InfoTabShelvesPage,
        path: ROUTES.PointShelves,
        title: "Market shelves",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam"],
    },
    {
        component: InfoTabPlanPage,
        path: ROUTES.PointPlan,
        title: "Market plan",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "svm"],
    },
    {
        component: AddContractPage,
        path: ROUTES.PointAddContract,
        title: "AddContract",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: ProductDetailsPage,
        path: ROUTES.ProductPage,
        title: "Upsells",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "md", "svm", "kam"],
    },

    // Tasks
    {
        component: AssignmentTaskPage,
        path: ROUTES.AssignmentTask,
        title: "Assignments task",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    {
        component: DMPPage,
        path: ROUTES.DMP,
        title: "Install DPM",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    {
        component: PromoTagPhotosPage,
        path: ROUTES.PromoTagPhotos,
        title: "Photo of promotional price tags",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "md", "ta", "kam"],
    },
    {
        component: AssortmentMatrixPage,
        path: ROUTES.AssortmentMatrix,
        title: "Асортиментна матриця",
        isPrivate: true,
        allowedRoles: ["svm", "md", "kam"],
    },
    {
        component: TakeDebtPage,
        path: ROUTES.TakeDebtTask,
        title: "Point details",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: SalePage,
        path: ROUTES.SaleAdditionalTask,
        title: "Upsells",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: PromoPage,
        path: ROUTES.SaleAdditionalPromoTask,
        title: "Promo",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: UpdateMarketInfoPage,
        path: ROUTES.UpdateMarketInfoTask,
        title: "Update market info",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    {
        component: SendGeoPage,
        path: ROUTES.SetGeoLocationTask,
        title: "SetGeoLocation",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    {
        component: AddPhotoPage,
        path: ROUTES.AddPhotoTask,
        title: "AddPhoto",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta", "md", "kam"],
    },
    {
        component: InventoryProductsPage,
        path: ROUTES.UpdateProductBalancesTask,
        title: "Inventory Products ",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: RejectProductsPage,
        path: ROUTES.RejectProductsTask,
        title: "Reject Products",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: ShelfSizePage,
        path: ROUTES.ShelfSizeTask,
        title: "ShelfSize",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },
    {
        component: PaidShelfSpacePage,
        path: ROUTES.PaidShelfSpaceTask,
        title: "Paid Shelf Space",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "ta"],
    },

    // Checkout
    {
        component: CheckoutPage,
        path: ROUTES.Checkout,
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["ta", "sv"],
    },
    {
        component: OrderDetailsPage,
        path: ROUTES.CheckoutOrderDetails,
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["ta", "sv"],
    },
    {
        component: CheckoutAddProductsPage,
        path: ROUTES.CheckoutAddProducts,
        title: "FAQ",
        isPrivate: true,
        allowedRoles: ["ta", "sv", "svm"],
    },

    // SV
    {
        component: TeamSVPage,
        path: ROUTES.Team,
        title: "Team",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: MemberInfoSVPage,
        path: ROUTES.TeamUserDetail,
        title: "Member",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: RouteManagementSVPage,
        path: ROUTES.RouteManagement,
        title: "Member",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementCreate,
        title: "NewRoute",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementEdit,
        title: "Edit Route",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: ViewByDaysOfMonth,
        path: ROUTES.RouteManagementDaysView,
        title: "View routes by days of month",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: AddMarketSVPage,
        path: ROUTES.RouteManagementAddPoint,
        title: "Add market",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "kam"],
    },
    {
        component: AddMarketSVPage,
        path: ROUTES.RouteManagementCreateAddPoint,
        title: "Add market",
        isPrivate: true,
        allowedRoles: ["sv", "svm"],
    },
    {
        component: RouteEditorSVPage,
        path: ROUTES.RouteManagementMyRoute,
        title: "Edit My Route",
        isPrivate: true,
        allowedRoles: ["kam"],
    },
    {
        component: CheckoutSVPage,
        path: ROUTES.SVCheckout,
        title: "Checkout",
        isPrivate: true,
        allowedRoles: ["sv"],
    },
    {
        component: CheckoutPage,
        path: ROUTES.SVCheckoutRoute,
        title: "Agent checkout",
        isPrivate: true,
        allowedRoles: ["sv"],
    },
    {
        component: MarketCreate,
        path: ROUTES.NewRoutePointCreate,
        title: "Market create",
        isPrivate: true,
        allowedRoles: ["sv", "svm", "kam"],
    },
];
